<template>
  <NavMenu />
  <section class="border-t">
    <div class="bg-brand-blue py-8 px-5">
      <div class="max-w-7xl mx-auto">
        <div class="text-white">
          <div class="">
            <div class="text-sm font-bold text-gray-200 mb-5">
              Home / documents
            </div>
            <h1 class="text-3xl font-bold">Contact</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="py-20">
      <form @submit.prevent="submit">
        <div class="max-w-7xl mx-auto">
          <div
            class="rounded-lg px-5 py-3 bg-yellow-300 text-center text-sm mb-5"
            v-if="hasSubmitted"
          >
            You message has been submitted. Thank you
          </div>
          <div class="grid lg:grid-cols-3 gap-8">
            <div class="lg:col-span-2">
              <div class="grid grid-cols-1 gap-6 mb-8">
                <label class="block">
                  <span class="text-gray-700">Full name</span>
                  <input
                    v-model="form.fullName"
                    type="text"
                    class="
                      mt-1
                      block
                      w-full
                      rounded-md
                      border-gray-300
                      shadow-sm
                      focus:border-indigo-300
                      focus:ring
                      focus:ring-indigo-200
                      focus:ring-opacity-50
                    "
                    placeholder=""
                  />
                </label>
                <label class="block">
                  <span class="text-gray-700">Email address</span>
                  <input
                    v-model="form.email"
                    type="email"
                    class="
                      mt-1
                      block
                      w-full
                      rounded-md
                      border-gray-300
                      shadow-sm
                      focus:border-indigo-300
                      focus:ring
                      focus:ring-indigo-200
                      focus:ring-opacity-50
                    "
                  />
                </label>
                <label class="block">
                  <span class="text-gray-700">Contact Number</span>
                  <input
                    v-model="form.contactNumber"
                    type="text"
                    class="
                      mt-1
                      block
                      w-full
                      rounded-md
                      border-gray-300
                      shadow-sm
                      focus:border-indigo-300
                      focus:ring
                      focus:ring-indigo-200
                      focus:ring-opacity-50
                    "
                  />
                </label>
                <label class="block">
                  <span class="text-gray-700">You message</span>
                  <textarea
                    v-model="form.message"
                    class="
                      mt-1
                      block
                      w-full
                      rounded-md
                      border-gray-300
                      shadow-sm
                      focus:border-indigo-300
                      focus:ring
                      focus:ring-indigo-200
                      focus:ring-opacity-50
                    "
                    rows="3"
                  ></textarea>
                </label>
              </div>
              <div>
                <button
                  class="btn btn-primary"
                  :disabled="$store.getters['contact/loading']"
                >
                  <span v-if="$store.getters['contact/loading']"
                    >Sending...</span
                  >
                  <span v-else>Submit</span>
                </button>
              </div>
            </div>
            <div>
              <div class="mb-8">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d399.19049947123136!2d73.51699634636164!3d4.17118523644447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b3f7ef90a2eca9f%3A0xdab58c21fe6d54dc!2sMaldives%20Marine%20Research%20Institute!5e0!3m2!1sen!2smv!4v1660888754663!5m2!1sen!2smv"
                  width="100%"
                  height="450"
                  style="border: 0"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div class="rounded-lg border p-5">
                <div class="block_contacts">
                  <h4 class="font-bold">Contact Us</h4>
                  <hr class="my-3" />

                  <div
                    class="flex space-x-3 mb-3 text-gray-600"
                    v-for="(row, i) in address"
                    :key="i"
                  >
                    <div>
                      <component class="w-6 h-6 text-gray-500" :is="row.icon" />
                    </div>
                    <div class="flex-1" v-html="row.txt"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
  <SectionFooter />
</template>

<script setup>
import NavMenu from "@/components/NavMenu";
import SectionFooter from "@/components/SectionFooter";
import {
  LocationMarkerIcon,
  PhoneIcon,
  MailIcon,
  GlobeAltIcon,
} from "@heroicons/vue/solid";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";

const store = useStore();
let form = ref({
  fullName: "",
  email: "",
  contactNumber: "",
  message: "",
});

const address = [
  {
    txt: "Maldives Marine Research Institute<br>H. White Waves Moonlight Higun<br>Malé- 20025<br>Republic of Maldives",
    icon: LocationMarkerIcon,
  },
  {
    txt: "Phone: +(960) 332-2242",
    icon: PhoneIcon,
  },
  {
    txt: 'E-mail: <a class="text-blue-600 hover:underline" href="mailto:info@mmri.gov.mv">info@mmri.gov.mv</a>',
    icon: MailIcon,
  },
  {
    txt: 'Web: <a class="text-blue-600 hover:underline" href="https://www.mrc.gov.mv/">www.mrc.gov.mv</a>',
    icon: GlobeAltIcon,
  },
];

let hasSubmitted = ref(false);

function submit() {
  hasSubmitted.value = false;
  store
    .dispatch("http/send", {
      module: "contact",
      method: "POST",
      commit: false,
      data: form.value,
    })
    .then(() => {
      hasSubmitted.value = true;
    });
}

//+917994896873;
</script>